module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "odiv"
  }, [_c('p', {
    staticClass: "charg_p"
  }, [_vm._v("\n        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.routerId),
      expression: "!this.routerId"
    }]
  }, [_vm._v("新增患者")]), _vm._v("\n        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.routerId),
      expression: "this.routerId"
    }]
  }, [_vm._v("修改详情")])]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('el-row', {
    staticClass: "containRow",
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "姓名"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("* ")]), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "性别"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("* ")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.gender),
      callback: function($$v) {
        _vm.$set(_vm.form, "gender", $$v)
      },
      expression: "form.gender"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "男"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "女"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "类型"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("* ")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.diagnosisType),
      callback: function($$v) {
        _vm.$set(_vm.form, "diagnosisType", $$v)
      },
      expression: "form.diagnosisType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "新诊"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "复诊"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "会员等级"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("* ")]), _vm._v(" "), _c('el-select', {
    on: {
      "change": function($event) {
        return _vm.selectOne(_vm.levelSelected)
      }
    },
    model: {
      value: (_vm.levelSelected),
      callback: function($$v) {
        _vm.levelSelected = $$v
      },
      expression: "levelSelected"
    }
  }, _vm._l((_vm.userLevelType), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.levelName
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("这里的等级选择不影响积分,办卡如需增加相应积分请选择“当前积分”后的按钮，系统会增加相应积分并更新等级")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "当前积分"
    }
  }, [_vm._v("\n              "), _c('el-input', {
    staticStyle: {
      "height": "30px",
      "width": "22%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.scoreAvail),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoreAvail", $$v)
      },
      expression: "form.scoreAvail"
    }
  }), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("银卡+1000积分")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("金卡+2000积分")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("白金卡+4000积分")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "证件号码"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("* ")]), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "请输入身份证号"
    },
    on: {
      "blur": function($event) {
        $event.preventDefault();
        return _vm.changeCount()
      }
    },
    model: {
      value: (_vm.form.idNumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "idNumber", $$v)
      },
      expression: "form.idNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "手机号"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("* ")]), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    model: {
      value: (_vm.form.mobileNumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobileNumber", $$v)
      },
      expression: "form.mobileNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "出生年月"
    }
  }, [_vm._v("\n                "), _c('el-input', {
    staticClass: "input",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.form, "dateOfBirth", $$v)
      },
      expression: "form.dateOfBirth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "周岁"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("* ")]), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.age),
      callback: function($$v) {
        _vm.$set(_vm.form, "age", $$v)
      },
      expression: "form.age"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "账号"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("* ")]), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "账号默认为手机号",
      "disabled": ""
    },
    model: {
      value: (_vm.form.account),
      callback: function($$v) {
        _vm.$set(_vm.form, "account", $$v)
      },
      expression: "form.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.routerId),
      expression: "!this.routerId"
    }],
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "密码"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("* ")]), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.routerId),
      expression: "this.routerId"
    }],
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "密码"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("* ")]), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.psw),
      callback: function($$v) {
        _vm.psw = $$v
      },
      expression: "psw"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.routerId),
      expression: "this.routerId"
    }],
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "现住址"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("* ")]), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.routerId),
      expression: "!this.routerId"
    }],
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "现住址"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("* ")]), _vm._v(" "), _c('el-cascader', {
    ref: "cascaderAddr",
    attrs: {
      "options": _vm.CityInfo,
      "change-on-select": true,
      "clearable": true
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.form.selectedOptions),
      callback: function($$v) {
        _vm.$set(_vm.form, "selectedOptions", $$v)
      },
      expression: "form.selectedOptions"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "height": "30px",
      "width": "48%"
    },
    attrs: {
      "placeholder": "详细地址: 如道路、门牌号、小区、楼栋号、单元室等"
    },
    model: {
      value: (_vm.form.detailAddress),
      callback: function($$v) {
        _vm.$set(_vm.form, "detailAddress", $$v)
      },
      expression: "form.detailAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱"
    }
  }, [_vm._v("\n                "), _c('el-input', {
    staticClass: "input",
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "职业"
    }
  }, [_vm._v("\n                "), _c('el-input', {
    staticClass: "input",
    model: {
      value: (_vm.form.professional),
      callback: function($$v) {
        _vm.$set(_vm.form, "professional", $$v)
      },
      expression: "form.professional"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "可用额度"
    }
  }, [_vm._v("\n                "), _c('el-input', {
    staticStyle: {
      "height": "30px",
      "width": "22%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.quota),
      callback: function($$v) {
        _vm.$set(_vm.form, "quota", $$v)
      },
      expression: "form.quota"
    }
  }), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.invest),
      callback: function($$v) {
        _vm.invest = $$v
      },
      expression: "invest"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("充卡5000送200")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("充卡10000送500")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 5
    }
  }, [_vm._v("自定义金额充卡"), _c('el-input', {
    staticStyle: {
      "height": "10px",
      "width": "22%"
    },
    model: {
      value: (_vm.form.recharge),
      callback: function($$v) {
        _vm.$set(_vm.form, "recharge", $$v)
      },
      expression: "form.recharge"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "提现余额"
    }
  }, [_vm._v("\n                "), _c('el-input', {
    staticStyle: {
      "height": "30px",
      "width": "22%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.deposit),
      callback: function($$v) {
        _vm.$set(_vm.form, "deposit", $$v)
      },
      expression: "form.deposit"
    }
  }), _vm._v(" "), (_vm.form.deposit > 0) ? _c('el-radio-group', {
    model: {
      value: (_vm.invest),
      callback: function($$v) {
        _vm.invest = $$v
      },
      expression: "invest"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("全额消费")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("余额退款")])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "额度透支"
    }
  }, [_vm._v("\n                "), _c('el-input', {
    staticStyle: {
      "height": "30px",
      "width": "22%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.overdraw),
      callback: function($$v) {
        _vm.$set(_vm.form, "overdraw", $$v)
      },
      expression: "form.overdraw"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "label": "提示"
    }
  }, [_vm._v("\n                带"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("的为必填字段\n\n            ")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.routerId),
      expression: "!this.routerId"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.create_user
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.routerId),
      expression: "this.routerId"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.update_user
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple Info"
  }, [(_vm.finish) ? _c('patientinquiry', {
    attrs: {
      "cmsg": _vm.objList2,
      "sex": _vm.form.gender,
      "rId": this.routerId
    },
    on: {
      "objList": _vm.objList
    }
  }) : _vm._e()], 1)])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a379c8e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/patient/addone.vue
// module id = 1023
// module chunks = 2